import React from 'react';

interface ErrorAlertProps {
  message: string;
  onDismiss?: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, onDismiss }) => {
  if (!message) return null;

  return (
    <div
      className="p-4 mb-4 text-sm text-red-200 bg-red-800/50 rounded-lg border border-red-700 flex justify-between items-start"
      role="alert"
    >
      <div>
        <span className="font-medium">Errore!</span> {message}
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="ml-4 -mt-1 -mr-1 p-1 text-red-200 hover:text-red-50 focus:outline-none focus:ring-2 focus:ring-red-400 rounded-md"
          aria-label="Chiudi"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default ErrorAlert;
